import React, { createContext, useContext } from 'react';
import { useCapabilities, Capabilities } from '../hooks/useCapabilities';

interface CapabilitiesContextValue {
  can: (capabilityKey: string) => boolean;
  capabilities: Capabilities;
  orgId: number | null;
  orgName: string | null;
  allCapabilities: boolean;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

const CapabilitiesContext = createContext<CapabilitiesContextValue>({
  can: () => false,
  capabilities: {},
  orgId: null,
  orgName: null,
  allCapabilities: false,
  loading: true,
  error: null,
  refresh: async () => {},
});

export const CapabilitiesProvider: React.FC<{
  orgId?: number | null;
  /** Staff/superuser: treat as full capability set even if /api/user/capabilities/ fails (e.g. stale org_id). */
  grantAllCapabilities?: boolean;
  children: React.ReactNode;
}> = ({ orgId, grantAllCapabilities, children }) => {
  const caps = useCapabilities(orgId, grantAllCapabilities);

  return (
    <CapabilitiesContext.Provider value={caps}>
      {children}
    </CapabilitiesContext.Provider>
  );
};

export function useCaps(): CapabilitiesContextValue {
  return useContext(CapabilitiesContext);
}
